<script>

    import { toast } from 'bulma-toast'
    import { userStore, accountsStore, modalStore } from '../stores'
    import AccountsService from '../$services/accounts.service.js'

    import Date from '../$components/date.svelte'
    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import Select from '../$components/select.svelte'
    import InputText from '../$components/input.text.svelte'

    let data = {autoRenew: true}

    let loading = false

    async function createAccount() {

        data.userId = $userStore._id

        loading = true
        const resp = await AccountsService.createAccount(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        accountsStore.append(resp.data)
        toast({message: 'Cuenta creada', type: 'is-success'})
    }
</script>

<Form on:submit={ createAccount } { loading } >

    <Select bind:value={data.cycleType} label="Tipo de ciclo" options={[
        {value: 'daily', text: 'Diario'},
        {value: 'weekly', text: 'Semanal'},
        {value: 'biweekly', text: 'Quincenal'},
        {value: 'monthly', text: 'Mensual'},
        {value: 'monthDays', text: 'Días del mes'},
    ]} />

    {#if data.cycleType === 'weekly'}
        <Select bind:value={data.cycleDay} label="Día de la semana (final del día)" options={[
            {value: 'Sunday', text: 'Domingo'},
            {value: 'Monday', text: 'Lunes'},
            {value: 'Tuesday', text: 'Martes'},
            {value: 'Wednesday', text: 'Miercoles'},
            {value: 'Thursday', text: 'Jueves'},
            {value: 'Friday', text: 'Viernes'},
            {value: 'Saturday', text: 'Sabado'},
        ]} />
    {/if}

    {#if data.cycleType === 'monthDays'}
        <InputText bind:value={data.monthDays} label="Días" placeholder="Separar con (,)" />
    {/if}

    <div class="field">
        <input bind:checked={data.autoRenew} type="checkbox" class="switch" id="check">
        <label for="check" class="label">Renovación automática</label>
    </div>

    <Date bind:value={data.activated} label="Fecha de inicio" />

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave icon="plus" text="Crear" {loading} />
    </div>

</Form>